import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

class TestimonialsSlider {

  constructor(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    this.root = node;
    this.swiper = this.root.querySelector('.TestimonialsSlider .swiper');
    this.nextEl = this.root.querySelector('.TestimonialsSlider-pagination .next');
    this.prevEl = this.root.querySelector('.TestimonialsSlider-pagination .prev');


    this._init();
  }

  _init() {

    Swiper.use([Autoplay, Navigation]);

    new Swiper(this.swiper, {
      slidesPerView: 1,
      direction: 'horizontal',
      spaceBetween: 20,
      loopedSlides: 2,
      speed: 1500,
      slidesPerGroup: 1,
      loop: true,
      navigation: {
        nextEl: this.nextEl,
        prevEl: this.prevEl,
      },
    });

  }
}

[...document.querySelectorAll('.TestimonialsSlider')].forEach(node => {
  new TestimonialsSlider(node);
});